import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '../../constants';


export class GATrackingFeatureFlagEvent implements GATrackingEvent  {

  constructor(
    private event: string,
    private category: string,
    private action: string,
    private label?: string
  ) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.FeatureFlag;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.event,
      label: this.label,
      gtmCustom: {
        action: this.action,
        category: this.category,
      }
    };
  }

}
